import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createPlan, updatePlan, deletePlan, retirePlan, type PlanPayload } from '../services/plans';
import { plansQueryKey } from './usePlansQuery';
import { planQueryKey } from './usePlanQuery';

export function usePlanMutations() {
    const queryClient = useQueryClient();

    const invalidateAll = () => queryClient.invalidateQueries({ queryKey: ['smr-admin', 'plans'] });

    return {
        createMutation: useMutation({
            mutationFn: (payload: PlanPayload) => createPlan(payload),
            onSuccess: invalidateAll,
        }),
        updateMutation: useMutation({
            mutationFn: ({ id, payload }: { id: string; payload: PlanPayload }) => updatePlan(id, payload),
            onSuccess: (_data, { id }) => {
                void queryClient.invalidateQueries({ queryKey: planQueryKey(id) });
                invalidateAll();
            },
        }),
        deleteMutation: useMutation({
            mutationFn: (id: string) => deletePlan(id),
            onSuccess: (_data, id) => {
                queryClient.removeQueries({ queryKey: planQueryKey(id) });
                invalidateAll();
            },
        }),
        retireMutation: useMutation({
            mutationFn: (id: string) => retirePlan(id),
            onSuccess: (_data, id) => {
                void queryClient.invalidateQueries({ queryKey: planQueryKey(id) });
                invalidateAll();
            },
        }),
    };
}

export { plansQueryKey };
